const {openPopupWindow} = require("../../../../../../../../../emitters/popup");
const Popup = require("../../../../../../../../dumb/Popup/C");
const FormMethods = require("../components/FormMethods").default;
const React = require("react");

module.exports = (data, update) => openPopupWindow((setPopupState, popup) => {
  const {close} = popup;

  return () => {
    return (
      <Popup
        caption={(
          <div className="layoutRow fhaS fvaC w">
            <div>Edit Methods Params</div>
          </div>
        )}
      >
        <FormMethods
          data={data}
          close={close}
          onResult={() => {
            update();
            close();
          }}
        />
      </Popup>
    );
  };
});
